module.exports = __webpack_public_path__ + "045ccf764a3b09a056f171383e14f81e.glb";